import { post } from '../services/common/common.service';
import { entitlementsSiteActivityEndPoints } from '../constants/endpoint';

//Entitlement Search By ID - GET API to fetch the data
export const fetchEntitlementSiteActivityData = (payload) => {
  return post(entitlementsSiteActivityEndPoints.getEntitlementsSiteActivity, payload); 
};

// Entitlements site activity API Job run
export const entitlementSiteActivityJob = (payload) => {
  return post(entitlementsSiteActivityEndPoints.entitlementSiteActivityJob, payload); 
};
